import * as z from "zod";

const HEX_COLOR_CODE_PREFIX = "#";
const HEX_COLOR_CODE_LENGTHS = [6, 8];

const HexColorString = z
  .string()
  .optional()
  .refine(
    (val) => {
      if (val === undefined || val === null || val === "") {
        return true;
      }
      if (typeof val === "string") {
        if (val[0] !== HEX_COLOR_CODE_PREFIX) {
          return false;
        }
        val = val.slice(1);
        if (z.hex().safeParse(val).success) {
          if (HEX_COLOR_CODE_LENGTHS.some((l) => l === val?.length)) {
            return true;
          }
          return false;
        }
      }

      return false;
    },
    {
      message: "Please enter a 6- or 8-digit HEX code",
    },
  );

const LogoUrlValidExtensions = ["png"];

const LogoUrlErrorMessage = () => {
  let errorMessage = "Please provide a direct web link ending in";
  let isFirst = true;
  const validExtensionsCount = LogoUrlValidExtensions.length;
  LogoUrlValidExtensions.forEach((extension, idx) => {
    if (isFirst) {
      errorMessage += ` .${extension}`;
      isFirst = false;
    } else if (idx + 1 === validExtensionsCount) {
      errorMessage += ` or .${extension}`;
    } else {
      errorMessage += `, .${extension} `;
    }
  });

  return errorMessage;
};

const LogoUrl = z
  .url({
    error: () => {
      return LogoUrlErrorMessage();
    },
  })
  .or(z.literal(""))
  .refine(
    (val) => {
      if (val === undefined || val === null || val === "") {
        return true;
      }

      if (typeof val === "string") {
        for (const extension of LogoUrlValidExtensions) {
          if (val.endsWith(`.${extension}`)) {
            return true;
          }
        }
      }

      return false;
    },
    {
      error: LogoUrlErrorMessage,
    },
  )
  .optional();

export const clientCustomizationFormSchema = z.object({
  button_color_hex: HexColorString,
  text_color_hex: HexColorString,
  favicon_url: z.string().optional(),
  name: z.string().optional(),
  public_name: z.string().optional(),
  extra_price_label: z.string().optional(),
  platform_commission_label: z.string().optional(),
  protection_fee_label: z.string().optional(),
  collect_phone_number: z.boolean().optional(),
  display_client_charge: z.boolean().optional(),
  logo_url: LogoUrl,
});
